module.exports = __webpack_public_path__ + "static/img/drawer4.2997d14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/page/drawer/drawer4.png
// module id = zk+R
// module chunks = 12